import { render, staticRenderFns } from "./DocumentField.vue?vue&type=template&id=5a9cba36&"
import script from "./DocumentField.vue?vue&type=script&lang=js&"
export * from "./DocumentField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports